// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toast-list {
  position: fixed;
  right: 1.25rem;
  top: 1.25rem;
  z-index: 999999999;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.5rem;
  width: -moz-fit-content;
  width: fit-content;
  max-width: min(420px, 94vw);
}

.Toast {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  background: var(--bg-white);
  border: 1px solid var(--border-color);
  border-left: 4px solid var(--color-gray-400);
  padding: 0.75rem 1rem;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1), 0 1px 4px rgba(0, 0, 0, 0.06);
  width: 100%;
  min-width: 280px;
  transition: transform 0.3s ease, opacity 0.3s ease, box-shadow 0.15s ease;
  animation: toastIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.Toast-icon {
  font-size: 16px;
  flex-shrink: 0;
  margin-top: 1px;
}
.Toast-body {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.Toast:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08);
}

@keyframes toastIn {
  from {
    opacity: 0;
    transform: translateX(24px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.success {
  border-left-color: var(--color-green);
}
.success .Toast-icon {
  color: var(--color-green);
}

.error {
  border-left-color: var(--color-red);
}
.error .Toast-icon {
  color: var(--color-red);
}

.info {
  border-left-color: var(--color-blue-primary);
}
.info .Toast-icon {
  color: var(--color-blue-primary);
}

.warn {
  border-left-color: var(--color-orange);
}
.warn .Toast-icon {
  color: var(--color-orange);
}

.Toast span {
  flex: 1 1;
  font-size: 15px;
  font-weight: 500;
  color: var(--color-gray-800);
  line-height: 1.4;
}

.Toast p {
  font-size: 14px;
  color: var(--color-gray-500);
  margin: 0;
}

.close-button {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  flex-shrink: 0;
  transition: background 0.15s ease;
}
.close-button:hover {
  background: var(--bg-gray-hover);
}
.close-button i {
  font-size: 15px;
  color: var(--color-gray-400);
}

.Toast.fadeOut {
  opacity: 0;
  transform: translateX(32px);
  transition: opacity 0.35s ease-out, transform 0.35s ease-out;
}`, "",{"version":3,"sources":["webpack://./../../shared/src/componets/feedback/ToastList/Toast.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,WAAA;EACA,uBAAA;EAAA,kBAAA;EACA,2BAAA;AACJ;;AAEA;EACI,aAAA;EACA,uBAAA;EACA,YAAA;EACA,2BAAA;EACA,qCAAA;EACA,4CAAA;EACA,qBAAA;EACA,mBAAA;EACA,wEAAA;EACA,WAAA;EACA,gBAAA;EACA,yEAAA;EACA,oDAAA;AACJ;AACI;EACI,eAAA;EACA,cAAA;EACA,eAAA;AACR;AAEI;EACI,SAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAAR;AAGI;EACI,yEAAA;AADR;;AAKA;EACI;IACI,UAAA;IACA,2BAAA;EAFN;EAIE;IACI,UAAA;IACA,wBAAA;EAFN;AACF;AAKA;EACI,qCAAA;AAHJ;AAII;EAAc,yBAAA;AADlB;;AAIA;EACI,mCAAA;AADJ;AAEI;EAAc,uBAAA;AAClB;;AAEA;EACI,4CAAA;AACJ;AAAI;EAAc,gCAAA;AAGlB;;AAAA;EACI,sCAAA;AAGJ;AAFI;EAAc,0BAAA;AAKlB;;AAFA;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;EACA,gBAAA;AAKJ;;AAFA;EACI,eAAA;EACA,4BAAA;EACA,SAAA;AAKJ;;AAFA;EACI,uBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,iCAAA;AAKJ;AAHI;EAAU,gCAAA;AAMd;AAJI;EACI,eAAA;EACA,4BAAA;AAMR;;AAFA;EACI,UAAA;EACA,2BAAA;EACA,4DAAA;AAKJ","sourcesContent":[".toast-list {\n    position: fixed;\n    right: 1.25rem;\n    top: 1.25rem;\n    z-index: 999999999;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 0.5rem;\n    width: fit-content;\n    max-width: min(420px, 94vw);\n}\n\n.Toast {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.75rem;\n    background: var(--bg-white);\n    border: 1px solid var(--border-color);\n    border-left: 4px solid var(--color-gray-400);\n    padding: 0.75rem 1rem;\n    border-radius: 10px;\n    box-shadow: 0 4px 16px rgba(0,0,0,0.1), 0 1px 4px rgba(0,0,0,0.06);\n    width: 100%;\n    min-width: 280px;\n    transition: transform 0.3s ease, opacity 0.3s ease, box-shadow 0.15s ease;\n    animation: toastIn 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n\n    &-icon {\n        font-size: 16px;\n        flex-shrink: 0;\n        margin-top: 1px;\n    }\n\n    &-body {\n        flex: 1;\n        display: flex;\n        flex-direction: column;\n        gap: 2px;\n    }\n\n    &:hover {\n        box-shadow: 0 8px 24px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.08);\n    }\n}\n\n@keyframes toastIn {\n    from {\n        opacity: 0;\n        transform: translateX(24px);\n    }\n    to {\n        opacity: 1;\n        transform: translateX(0);\n    }\n}\n\n.success {\n    border-left-color: var(--color-green);\n    .Toast-icon { color: var(--color-green); }\n}\n\n.error {\n    border-left-color: var(--color-red);\n    .Toast-icon { color: var(--color-red); }\n}\n\n.info {\n    border-left-color: var(--color-blue-primary);\n    .Toast-icon { color: var(--color-blue-primary); }\n}\n\n.warn {\n    border-left-color: var(--color-orange);\n    .Toast-icon { color: var(--color-orange); }\n}\n\n.Toast span {\n    flex: 1;\n    font-size: 15px;\n    font-weight: 500;\n    color: var(--color-gray-800);\n    line-height: 1.4;\n}\n\n.Toast p {\n    font-size: 14px;\n    color: var(--color-gray-500);\n    margin: 0;\n}\n\n.close-button {\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    padding: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 20px;\n    height: 20px;\n    border-radius: 4px;\n    flex-shrink: 0;\n    transition: background 0.15s ease;\n\n    &:hover { background: var(--bg-gray-hover); }\n\n    i {\n        font-size: 15px;\n        color: var(--color-gray-400);\n    }\n}\n\n.Toast.fadeOut {\n    opacity: 0;\n    transform: translateX(32px);\n    transition: opacity 0.35s ease-out, transform 0.35s ease-out;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
